'use strict'

import template from './blocked-toast.template.pug'

export class BlockedToastController {
  constructor($mdToast, $mdDialog) {
    'ngInject'
    Object.assign(this, { $mdToast, $mdDialog })
  }

  close() {
    this.$mdToast.hide()
  }

  openSupportDialog() {
    const requestSupportDialog = this.$mdDialog.requestSupportDialog({
      fullscreen: true,
      locals: {
        customer: this.customer,
      },
    })
    this.$mdDialog.show(requestSupportDialog)

    this.close()
  }
}

export const blockedToastConfig = ($mdToastProvider) => {
  'ngInject'

  $mdToastProvider.addPreset('blockedToast', {
    options: () => {
      return {
        template: template(),
        controllerAs: '$ctrl',
        controller: BlockedToastController,
      }
    },
  })
}



// WEBPACK FOOTER //
// ./app/customers/components/blocked-toast/blocked-toast.component.js